import React, { useEffect, useState } from "react";
import { ReactTitle } from "react-meta-tags";
import Modal from "../../../utils/customModal";
import { useDispatch } from "react-redux";
import { instanceAction } from "../../../../Redux/api";
import { MOD_CUSTOM, WRITE } from "../../../../permissions/";
import SecondaryButton from "canvas-core-react/lib/SecondaryButton";
import {
  moduleAction,
  loadingHtml,
  errorContainer,
  sucessInfoModal,
} from "../../../utils/functions";
import UserAddIco from "../../../../../static/images/user-add-black.svg";

import CheckBox from "canvas-core-react/lib/Checkbox";
import Selector from "canvas-core-react/lib/Selector";
import { useTranslation } from "react-i18next";

const Services = (props) => {
  const dispatch = useDispatch();
  const [modal, setModal] = useState({
    show: false,
    content: null,
    onClose: undefined,
  });
  const [checkedModules, setCheckedModules] = useState({});
  const [approvals, setApprovals] = useState({});
  const [edited, setEdited] = useState(false);

  const { permissions } = props;

  useEffect(() => {
    getDefaultModules();
  }, []);

  const getDefaultModules = () => {
    var moduleData = {};
    var approvalData = {};

    props.modulo.map((module) => {
      /* istanbul ignore else */
      if (module.hasModule) {
        moduleData[`service-${module.module.id}`] = {
          moduleId: module.module.id,
        };
        approvalData[`service-${module.module.id}`] = {
          numberOfApprovals: module.formatType || module.numberOfApprovals,
        };
      }
    });

    setCheckedModules(moduleData);
    setApprovals(approvalData);
  };

  const closeModal = (refresh = false) => {
    setModal({ show: false, content: null, onClose: undefined });
    /* istanbul ignore else */
    if (refresh) {
      setEdited(false);
      props.getModules();
    }
  };

  const handlerChange = (event) => {
    var currentModules = { ...checkedModules };
    /* istanbul ignore else */
    if (!edited) {
      setEdited(true);
    }

    /* istanbul ignore else */
    if (
      currentModules[event.target.name] !== undefined &&
      !event.target.checked
    ) {
      delete currentModules[event.target.name];
    } else if (event.target.checked === true) {
      currentModules[event.target.name] = {
        moduleId: event.target.id.split("-")[1],
      };
    }
    setCheckedModules(currentModules);
  };

  const selectedChange = (event) => {
    /* istanbul ignore else */
    if (!edited) {
      setEdited(true);
    }
    var currentApprovals = { ...approvals };

    currentApprovals[event.target.name] = {
      numberOfApprovals: event.target.value,
    };

    setApprovals(currentApprovals);
  };

  const modalFunction = () => {
    const buttons = {
      SelBtn: { text: "Aceptar", action: () => closeModal(true) },
    };

    const content = sucessInfoModal(request.title, request.subtitle, buttons);
    setModal({ show: true, content, onClose: () => closeModal(true) });
  };

  const getData = () => {
    setModal({ show: true, content: loadingHtml(), onClose: undefined });

    var data = [];
    Object.keys(checkedModules).map((key) => {
      let obj = { moduleId: parseInt(checkedModules[key].moduleId, 10) };

      obj = {
        ...obj,
        numberOfApprovals: approvals[key]
          ? parseInt(approvals[key].numberOfApprovals, 10)
          : 0,
      };

      return data.push(obj);
    });

    data.push({
      moduleId: 10,
      formatType: "UNIFICADO",
    });

    return dispatch(instanceAction(props.createUrl, props.createMethod, data))
      .then(() => {
        modalFunction();
      })
      .catch((err) => {
        /* istanbul ignore else */
        if (
          err.response !== undefined &&
          Array.isArray(err.response.data.notifications)
        ) {
          const notification = err.response.data.notifications[0];
          var content = errorContainer(
            notification.message,
            notification.description
          );
        }
        setModal({ show: true, content, onClose: () => closeModal() });
      });
  };

  const cancel = () => {
    setEdited(false);
    getDefaultModules();
  };

  const { t } = useTranslation();

  const { buttons, mainTitle, request, titles } = {
    mainTitle: `${t("providers.title")} - ${t("providers.tabs.1")}`,
    titles: t("services.options", { returnObjects: true }),
    request: t("services.successRequest", { returnObjects: true }),
    buttons: t("general.buttons", { returnObjects: true }),
  };

  return (
    <React.Fragment>
      <ReactTitle title={mainTitle} />
      <div className="clearfix service-container">
        <div key={`module-header`} className="loaded-module">
          <h2 className="flex-element">
            <img src={UserAddIco} /> {titles.title}
          </h2>
          <h2><strong>{titles.numberApprovals}</strong></h2>
        </div>
        {props.modulo &&
          props.modulo.map((module, key) => (
            <div key={`${module.id}-${key}`} className="loaded-module">
              <CheckBox
                key={`${module.module.code}-${module.module.code}`}
                id={`service-${module.module.id}`}
                name={`service-${module.module.id}`}
                label={module.module.displayName}
                checked={
                  checkedModules[`service-${module.module.id}`] !== undefined
                }
                disabled={
                  module.module.code === "MOD_DISCONT_PROV"
                    ? true
                    : moduleAction(props.roles, MOD_CUSTOM, WRITE)
                    ? false
                    : true
                }
                onChange={(event) => handlerChange(event)}
                className="changes"
              />
              {!permissions.noApprovals.includes(module.module.code) && (
                <Selector
                  placeholder={`${
                    module.module.code === "MOD_FORMAT_TYPE"
                      ? module.formatType === null
                        ? "formato"
                        : module.formatType
                      : module.numberOfApprovals == 100
                      ? "Aprobación Global"
                      : `${module.numberOfApprovals}`
                  }`}
                  className="no-label"
                  id={`selector-${module.module.id}`}
                  name={`service-${module.module.id}`}
                  label=""
                  onChange={(event) => selectedChange(event)}
                  value={
                    approvals[`service-${module.module.id}`] !== undefined
                      ? `${
                          approvals[`service-${module.module.id}`]
                            .numberOfApprovals
                        }`
                      : `0`
                  }
                  disabled={
                    moduleAction(props.roles, MOD_CUSTOM, WRITE) ? false : true
                  }
                >
                  {permissions[module.module.code] !== undefined
                    ? permissions[module.module.code].map((option) => (
                        <option
                          key={`option-${option.value}`}
                          value={option.value}
                        >
                          {option.label}
                        </option>
                      ))
                    : permissions["default"].map((option) => (
                        <option
                          key={`option-${option.value}`}
                          value={option.value}
                        >
                          {option.label}
                        </option>
                      ))}
                </Selector>
              )}
            </div>
          ))}
        <div className="form-actions clearfix">
          {moduleAction(props.roles, MOD_CUSTOM, WRITE) && (
            <>
              <SecondaryButton
                id={`cancel-btn`}
                className="btnLimpiar"
                disabled={!edited}
                onClick={cancel}
              >
                {buttons.cancel}
              </SecondaryButton>
              <SecondaryButton
                id={`process-btn`}
                className="btnAgregar"
                disabled={!edited}
                onClick={getData}
              >
                {buttons.sendForApproval}
              </SecondaryButton>
            </>
          )}
        </div>
      </div>
      <Modal
        key={`provider-users`}
        show={modal.show}
        handleClose={modal.onClose}
      >
        {modal.content}
      </Modal>
    </React.Fragment>
  );
};

export default Services;
